import React, { useState } from 'react';
import DataTable from 'react-data-table-component';
import { urlApiProd } from '../utiles';

const AgregarCategoria = ({ cerrar, calidades }) => {
    const [botonDeshabilitado, setBotonDeshabilitado] = useState(false);
    const [nombre, setNombre] = useState('');
    const [ingles, setIngles] = useState('');
    const [portugues, setPortugues] = useState('');
    const [Calidades, setCalidades] = useState([]);
    const [nuevaCalidad, setNuevaCalidad] = useState(null);
    const [ncm, setNcm] = useState('');

    const handleSubmit = (event) => {
        event.preventDefault();
        setBotonDeshabilitado(true);

        const arregloCalidades = Calidades.map(cal => parseInt(cal.id_calidad));
        const nuevaCategoria = {
            nombre,
            nombre_ingles: ingles,
            nombre_portugues: portugues,
            calidades: arregloCalidades,
            ncm
        };

        const token = localStorage.getItem('token');

        fetch(`${urlApiProd}/agregarcategoria`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(nuevaCategoria),
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Error al agregar categoría');
                }
                return response.json();
            })
            .then(data => {
                console.log('Categoría agregada:', data);
                alert('Categoría ' + nombre + ' agregada exitosamente');
                // window.location.reload(); 
                cerrar({
                    id_categoria: data.id_categoria,
                    nombre,
                    nombre_ingles: ingles,
                    nombre_portugues: portugues,
                    ncm,
                    calidades: Calidades.map(cal => parseInt(cal.id_calidad))
                });
            })
            .catch(error => {
                console.error('Error:', error);
            })
            .finally(() => {
                setBotonDeshabilitado(false);
            });
    }

    const columns = [
        {
            name: 'ID Calidad',
            selector: (row) => row.id_calidad
        },
        {
            name: 'Calidad',
            selector: row => {
                if (row.id_calidad) {
                    const calidadEncontrada = calidades.find(calidad => calidad.id_calidad === parseInt(row.id_calidad));
                    if (calidadEncontrada) {
                        return calidadEncontrada.calidad;
                    }
                }
            },
            width: '200px',
        },
        {
            name: 'Eliminar',
            cell: row => (
                <button
                    type="button"
                    className="btn btn-outline-danger"
                    onClick={() => {
                        if (window.confirm('¿Estás seguro?')) {
                            handleDeleteCalidad(row.id_calidad);
                        }
                    }}
                >
                    X
                </button>
            ),
            ignoreRowClick: true,
        },
    ];

    const handleAgregarCalidad = () => {
        setCalidades([
            ...Calidades,
            {
                id_calidad: nuevaCalidad
            }
        ]);
        setNuevaCalidad(null);
    };

    const handleDeleteCalidad = (id) => {
        const updatedCalidades = Calidades.filter((calidad) => calidad.ID_Calidad !== id);
        setCalidades(updatedCalidades);
    };

    return (
        <div className='modal-overlay'>
            <div className='modal1'>
                <div className='card'>
                    <form onSubmit={handleSubmit}>
                        <div className='card-header'>
                            <h3 className='card-title' style={{ textAlign: 'center' }}>Agregar Categoria</h3>
                        </div>
                        <div className='card-body'>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>Nombre</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ingrese categoría"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value)}
                                    required
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>En inglés</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ingrese categoría"
                                    value={ingles}
                                    onChange={(e) => setIngles(e.target.value)}
                                    required
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>En portugués</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ingrese categoría"
                                    value={portugues}
                                    onChange={(e) => setPortugues(e.target.value)}
                                    required
                                />
                            </div>
                            <div className='input-group mb-3'>
                                <span className='input-group-text'>NCM</span>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Ingrese NCM"
                                    value={ncm}
                                    onChange={(e) => setNcm(e.target.value)}
                                    required
                                />
                            </div>
                            <div className='mb-3'>
                                <h5>Calidades</h5>
                                <div className='input-group mb-3'>
                                    <span className='input-group-text'>
                                        Calidad
                                    </span>
                                    <select
                                        value={nuevaCalidad}
                                        onChange={e => setNuevaCalidad(e.target.value)}
                                        className='form-control'
                                    >
                                        <option value="">Seleccionar Calidad</option>
                                        {calidades.map((calidad) => {
                                            const calidadExistente = Calidades.some(cal => parseInt(cal.id_calidad) === parseInt(calidad.id_calidad));
                                            if (!calidadExistente) {
                                                return (
                                                    <option key={calidad.id_calidad} value={calidad.id_calidad}>
                                                        {calidad.calidad}
                                                    </option>
                                                );
                                            }
                                            return null;
                                        })}
                                    </select>
                                    <button type="button" onClick={handleAgregarCalidad} className="btn btn-outline-primary" disabled={!nuevaCalidad}>
                                        Agregar Calidad
                                    </button>
                                </div>
                                <DataTable
                                    columns={columns}
                                    data={Calidades}
                                    highlightOnHover
                                    dense
                                    pagination={true}
                                />
                            </div>
                        </div>
                        <div className='card-footer' style={{ textAlign: 'center' }}>
                            <button
                                type="submit"
                                className="btn btn-outline-success mb-3 mt-3"
                                disabled={botonDeshabilitado}
                            >
                                Agregar
                            </button>
                            <button type="button" className="btn btn-outline-danger" onClick={cerrar}>Cancelar</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AgregarCategoria;
